/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.moderation.getEvent'

export { $nsid }

/** Get details about a moderation event. */
const main = l.query(
  $nsid,
  l.params({ id: l.integer() }),
  l.payload(
    'application/json',
    l.ref<ModerationDefs.ModEventViewDetail>(
      (() => ModerationDefs.modEventViewDetail) as any,
    ),
  ),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
